export const getCNHCategories = () => [
  { label: "ACC", value: "ACC" },
  { label: "A", value: "A" },
  { label: "B", value: "B" },
  { label: "C", value: "C" },
  { label: "D", value: "D" },
  { label: "E", value: "E" }
];
